import React, { useEffect, useRef, useState } from 'react';
import './NewsTicker.css';
import { getSiteSettings } from '../api/siteSettingsApi';

const DEFAULT_MSGS = ['מבצע מיוחד לחברי מועדון!', 'הנחה 20% על כל תוכניות החודש', 'הזמינו עכשיו וקבלו קופון הנחה'];

const NewsTicker = () => {
  const [settings, setSettings] = useState({ enabled: true, items: [] });
  const containerRef = useRef();
  const scrollRef = useRef();
  const posRef = useRef(null);
  const rafRef = useRef();

  useEffect(() => {
    getSiteSettings().then(s => setSettings(s.ticker || { enabled: true, items: [] }));
    const onUpdate = (e) => setSettings(e.detail?.ticker || { enabled: true, items: [] });
    window.addEventListener('siteSettings:update', onUpdate);
    return () => window.removeEventListener('siteSettings:update', onUpdate);
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    const scroll = scrollRef.current;
    if (!container || !scroll) return;

    // רוחב בלוק אחד (חצי מהסקרול שמכיל 2 עותקים)
    const getHalfWidth = () => scroll.offsetWidth / 2;

    // התחל מחוץ למסך משמאל
    posRef.current = -getHalfWidth();
    scroll.style.transform = `translateX(${posRef.current}px)`;

    const speed = 2.5;

    const animate = () => {
      posRef.current += speed;
      // כשהבלוק הראשון יצא לגמרי - קפוץ בדיוק בלוק אחד אחורה
      if (posRef.current >= getHalfWidth()) {
        posRef.current -= getHalfWidth();
      }
      scroll.style.transform = `translateX(${posRef.current}px)`;
      rafRef.current = requestAnimationFrame(animate);
    };

    rafRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafRef.current);
  }, [settings]);

  if (!settings.enabled) return null;

  const msgs = settings.items && settings.items.length > 0 ? settings.items : DEFAULT_MSGS;

  return (
    <div className="news-ticker-bar" ref={containerRef}>
      <div className="news-ticker-scroll" ref={scrollRef}>
        {msgs.map((text, idx) => (
          <span className="news-ticker-msg" key={idx}>
            {text}
            <span className="news-ticker-dot" />
          </span>
        ))}
        {msgs.map((text, idx) => (
          <span className="news-ticker-msg" key={'b' + idx}>
            {text}
            <span className="news-ticker-dot" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default NewsTicker;
